import { useEffect, type ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-auth";
import { hasRetail, hasRole } from "@/lib/roles";

type SessionUser = ReturnType<typeof useSession>["user"];

const isAdminUser = (user: SessionUser) => hasRole(user, "admin");

/** Stranica samo za admina; `allow` je zamjenjuje drugim pravilom (npr. admin ili dev za prijave). */
export function AdminOnly({
  children,
  allow = isAdminUser,
}: {
  children: ReactNode;
  allow?: (user: SessionUser) => boolean;
}) {
  const { user, isLoading } = useSession();
  const navigate = useNavigate();
  const isAdmin = allow(user);

  useEffect(() => {
    if (!isLoading && user && !isAdmin) {
      // Nalog bez maloprodaje ide ravno na veleprodajne narudžbe — bez međukoraka preko /orders.
      navigate({ to: hasRetail(user) ? "/orders" : "/wholesale/orders", replace: true });
    }
  }, [isLoading, user, isAdmin, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <p className="text-sm text-muted-foreground">Učitavanje...</p>
      </div>
    );
  }

  if (!user || !isAdmin) return null;
  return <>{children}</>;
}
